<template>
  <div class="flex flex-col md:w-1/2 m-auto bg-white py-3 px-5 md:px-8">
    <div class="flex py-1">
      <h5 class="">Getting Set Up</h5>
    </div>
    <div class="flex flex-row justify-between py-1">
      <div
        class="flex-1"
        v-for="(step, index) in steps"
        :key="index"
        :class="[index !== 0 && index !== step.length - 1 ? 'text-center' : '']"
      >
        <p
          :class="[
            currentStep === step ? 'font-semibold' : '',
            currentStepIndex >= index ? 'text-brand-green' : 'text-brand-mid-gray'
          ]"
        >
          {{ index + 1 }}. {{ step.label }}
        </p>
      </div>
    </div>
  </div>
  <div class="rounded-lg bg-white px-5 py-5 my-5 md:px-10 shadow-sm mx-auto md:max-w-screen-lg">
    <router-view />
  </div>
</template>
<script>
export default {
  computed: {
    currentStepIndex() {
      return this.steps.indexOf(this.currentStep)
    },
    currentStep() {
      const current = this.steps.filter((step) => step.routes.includes(this.$route.name))
      if (current.length) {
        return current[0]
      }
      return null
    }
  },
  data() {
    return {
      steps: []
    }
  },
  mounted() {
    if (this.$route.meta.steps) {
      this.steps = this.$route.meta.steps
    }
  }
}
</script>
